import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import {
  API_URL_SATELLITE_LIST,
  API_URL_SATELLITE_TYPE_LIST,
} from 'constants/index'
import NoticeHelper from 'helpers/notice'
import {
  SATELLITE_LIST,
  SATELLITE_LIST_FAILURE,
  SATELLITE_LIST_SUCCESS,
  SATELLITE_TYPE_LIST,
  SATELLITE_TYPE_LIST_FAILURE,
  SATELLITE_TYPE_LIST_SUCCESS,
} from './reducer'
import { SHOW_NOTICE } from '../notice'

function* satelliteList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_SATELLITE_LIST, {
        site: action.payload.site,
        type: action.payload.type,
        date: action.payload.date,
      }),
    })

    if (!response || !response.error) {
      yield put({ type: SATELLITE_LIST_SUCCESS, payload: response })

      if (!response.min) {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createSuccessObj(
            'No data please change filters!',
          ),
        })
      }
    } else {
      yield put({ type: SATELLITE_LIST_FAILURE, error: response.errors })
    }
  } catch (error) {
    console.log('SATELLITE ERROR', error)
  }
}

function* satelliteTypeList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(API_URL_SATELLITE_TYPE_LIST),
    })

    if (!response || !response.error) {
      yield put({ type: SATELLITE_TYPE_LIST_SUCCESS, payload: response })
    } else {
      yield put({ type: SATELLITE_TYPE_LIST_FAILURE, error: response.errors })
    }
  } catch (error) {
    console.log('SATELLITE TYPE ERROR', error)
  }
}

function* satellite() {
  yield takeLatest(SATELLITE_LIST, satelliteList)
  yield takeLatest(SATELLITE_TYPE_LIST, satelliteTypeList)
}

export default satellite
